<template>
  <FlotoDrawer :open="open" width="60%" @hide="close">
    <template v-slot:title>
      <div class="flex">
        <AssetTypeIcon
          v-bind="{
            ...(source.model === $constants.CMDB
              ? {
                  ciTypeId: source.assetTypeId,
                }
              : {
                  assetTypeId: source.assetTypeId,
                }),
          }"
          class="mr-3"
          size="lg"
        />
        {{ source.name }} {{ __tc('relationship', 2) }}
      </div>
    </template>
    <FlotoContentLoader :loading="loading">
      <MRow
        v-for="(relation, index) in relations"
        :key="relation.id"
        :gutter="0"
        class="mb-4 items-center relationship-container"
      >
        <MCol :size="4" class="flex items-center">
          <span class="mr-2">{{ index + 1 }}.</span>
          <div class="party-box flex flex-1 min-w-0">
            <AssetTypeIcon
              v-bind="{
                ...(source.model === $constants.CMDB
                  ? {
                      ciTypeId: source.assetTypeId,
                    }
                  : {
                      assetTypeId: source.assetTypeId,
                    }),
              }"
              class="mr-3"
              size="lg"
            />
            <div class="min-w-0 flex-1 text-ellipsis">
              {{ source.name }}: {{ source.displayName }}
            </div>
          </div>
        </MCol>
        <MCol :size="4" class="relation-name-col flex justify-center">
          <div class="relation-name-container min-w-0">
            <div class="relation-name text-ellipsis">
              {{ relation.relation }}
            </div>
          </div>
        </MCol>
        <MCol :size="4" class="flex items-center">
          <div class="party-box flex flex-1 min-w-0">
            <AssetTypeIcon
              v-if="relation.assetTypeId"
              v-bind="{
                ...(relation.model === $constants.CMDB
                  ? {
                      ciTypeId: relation.assetTypeId,
                    }
                  : {
                      assetTypeId: relation.assetTypeId,
                    }),
              }"
              class="mr-3"
              size="lg"
            />
            <MIcon
              v-else
              size="lg"
              class="mr-3 text-neutral-light"
              :name="getIconForResource(relation.model)"
            />
            <div class="min-w-0 flex-1 text-ellipsis">
              {{ relation.name }}
              {{ relation.displayName ? `: ${relation.displayName}` : '' }}
            </div>
          </div>
          <FlotoDeleteBtn
            class="ml-2"
            :message="$t('confirm_remove_item', { item: __tc('relationship') })"
            @confirm="removeRelationship(relation)"
          />
        </MCol>
      </MRow>
      <FlotoNoData v-if="relations.length === 0" />
    </FlotoContentLoader>
  </FlotoDrawer>
</template>

<script>
import AssetTypeIcon from '@components/custom-icon/asset-type-icon'
import {
  getAssetRelationshipsApi,
  deleteAssetRelationshipApi,
} from '../../asset-api'

export default {
  name: 'ViewRelationships',
  components: { AssetTypeIcon },
  props: {
    source: { type: Object, required: true },
    moduleName: { type: String, required: true },
  },
  data() {
    return {
      open: true,
      loading: true,
      relations: [],
    }
  },
  created() {
    this.getRelations()
  },
  methods: {
    getIconForResource(model) {
      if (model === 'user') {
        return 'user'
      }
      if (model === 'user_group') {
        return 'users'
      }
      if (model === 'department') {
        return 'building'
      }
    },
    getRelations() {
      getAssetRelationshipsApi(
        this.source.model,
        this.source.resourceId,
        this.moduleName
      ).then((data) => {
        this.relations = data
        this.loading = false
      })
    },
    removeRelationship(relation) {
      deleteAssetRelationshipApi(relation.id, this.moduleName).then(() => {
        this.$emit('remove')
        this.relations = this.relations.filter((r) => r.id !== relation.id)
      })
    },
    close() {
      this.open = false
      setTimeout(() => {
        this.$emit('hide')
      }, 400)
    },
  },
}
</script>

<style lang="less" scoped>
.relationship-container {
  @apply relative;

  .box {
    @apply relative bg-white;
  }

  .party-box {
    @apply rounded p-2 bg-white;

    background-color: var(--page-background-color);
    border: 1px solid var(--border-color);
  }

  .relation-name-col {
    @apply relative;

    &::before {
      position: absolute;
      top: 50%;
      right: 0;
      left: 0;
      height: 1px;
      content: ' ';
      background: @neutral-light;
    }
  }

  .relation-name-container {
    width: 70%;

    @apply inline-block relative;

    .relation-name {
      @apply rounded-lg py-2 bg-neutral text-white text-center px-6;
    }
  }
}
</style>
